import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { RouteItem } from '../../routes/RouteItem';
import { NavbarProps } from './Navbar.types';

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  top: 0;
  left: 0;
  right: 0;
  height: 3rem;

  top: 0;
  bottom: 0;
  width: auto;
  overflow-y: auto;

  color: ${props => props.theme.colors.sidebarText};
  background-color: ${props => props.theme.colors.sidebarBackground};

  z-index: 0;

  > h3 {
    color: white;
    margin: 0;
    padding: 4px;
  }
`;

function renderIcon(icon: ReactNode) {
  return typeof icon === 'string' && icon.includes('fa') ? (
    <i className={icon} />
  ) : (
    icon
  );
}

export const Navbar: FunctionComponent<NavbarProps> = props => {
  const location = useLocation();
  const activeRoute = (props.routes as RouteItem[]).find(
    route => route.path === location.pathname
  );

  if (!activeRoute) return null;

  return (
    <Container className="-mobile-only">
      <h3>
        {renderIcon(activeRoute.icon)} {activeRoute.title}
      </h3>
      {props.children}
    </Container>
  );
};
